<template>
  <div>
    <view-container>
      <v-container>
        <v-row>
          <v-col cols="2">
            <basic-btn
              xLarge
              icon="mdi-arrow-left"
              @click="$router.push('/client/Historic')"
            />
          </v-col>
          <v-col cols="10">
            <h1
              v-text="
                items
                  ? items[0].nombre
                    ? items[0].nombre
                    : 'Encuesta'
                  : 'Encuesta'
              "
            />
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row>
          <v-col cols="12" sm="12" md="12"> </v-col>
          <v-col cols="12" sm="12" md="12" class="out-padding">
            <auto-container style="overflow: auto;" color="#F7F9F9">
              <div v-for="(item, i) in items[0].preguntas" :key="item.key">
                <span
                  v-text="i + 1 + '.-' + item.pregunta"
                  class="colorLinde"
                />
                <br />
                <select-up
                  :info="item.opciones"
                  @click="selectData"
                  text="text"
                  v-if="item.tipo !== 'TL'"
                  label=""
                  :formReserv="i + 1"
                  :multiple="item.tipo === 'SM' ? true : false"
                />
                <BasicInput
                  v-model="newForm[i + 1]"
                  placeholder=""
                  v-if="item.tipo === 'TL'"
                  @input="sendValidation"
                  required
                />
              </div>
              <br />
              <hr />
              <br />

              <basic-btn
                block
                text="Enviar"
                @click="answerPost"
                :disabled="valid"
              />
            </auto-container>
          </v-col>
        </v-row>
      </v-container>
    </view-container>
  </div>
</template>

<script>
import moment from "moment";
import Scroller from "@/components/Scroller";
import { services, time, alertMsg } from "@/utils";

import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
  SearchBox,
  InfoList,
  SelectBtn,
  WeekBtn,
  SelectUp,
  InputBtn,
} from "@/components";

export default {
  name: "home",
  components: {
    AutoContainer,
    ViewContainer,
    BasicInput,
    BasicBtn,
    SearchBox,
    InfoList,
    SelectBtn,
    WeekBtn,
    Scroller,
    SelectUp,
    InputBtn,
  },
  data: () => ({
    items: [
      {
        id: 0,
        codigo: "",
        nombre: "",
        descripcion: "",
        preguntas: [],
      },
    ],
    newForm: {},
    valid: false,
  }),
  mounted() {
    this.items = this.$route.query;
  },
  methods: {
    selectData(info, name) {
      this.newForm[name] = info;
      this.sendValidation();
    },
    sendValidation() {
      this.valid =
        Object.keys(this.newForm).length !== this.items[0].preguntas.length;
    },
    answerPost() {
      let arrAux = this.newForm;
      const detalle = [];
      Object.keys(arrAux).map((i) => {
        const rObj = {
          pregunta: i,
          respuesta: arrAux[i].text
            ? arrAux[i].text
            : Array.isArray(arrAux[i])
            ? arrAux[i].join(",")
            : arrAux[i],
        };
        detalle.push(rObj);
      });

      let data = {
        data: {
          encuesta: this.items[0].id,
          detalle,
        },
      };
      services
        .ws("post", "surveyAnswer", data)
        .then((res) => {
          if (res.ok) {
            this.chekIn();
          }
        })
        .catch((error) => {
          alertMsg.alert(error.response.data.message, "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    chekIn() {
      let data = {
        data: { detReservacionID: this.$route.params.id },
      };
      services
        .ws("post", "checkIn", data)
        .then((res) => {
          if (res.ok) {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = "Notificacion enviada correctamente";
            alertMsg.alert("Registro realizado con exito", "success");
          } else {
            this.error = true;
            this.codeError = res.code;
            alertMsg.alert("Intentelo más tarde", "error");
          }
        })
        .catch((error) => {
          alertMsg.alert(error.response.data.message, "error");
        })
        .finally(() => {
          this.$router.push("/client/Historic/");
          this.loading = false;
        });
    },
    emptyJson() {
      let valid = false;
      let arrAux = this.newForm;

      Object.keys(arrAux).map((i) => {
        if (arrAux[i].text) {
          if (arrAux[i].text == "") {
            valid = true;
          }
        }
        if (arrAux[i]) {
          if (arrAux[i] == "") {
            valid = true;
          }
        }
      });

      return valid;
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}

.padding-t0 {
  padding-top: 0px;
}

.padding-t10 {
  padding-top: 3%;
}

.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

h1,
.colorLinde {
  color: #005591;
}

.colorLinde2 {
  color: #00a0e1;
}

.one {
  display: flex !important;
  align-items: flex-end !important;
}

.upImg {
  position: relative /* o absolute*/;
  top: 220px;
  left: 220px;
  z-index: 99;
}

.upImgG {
  position: relative /* o absolute*/;
  top: 220px;
  left: 320px;
  z-index: 99;
}
</style>
